<template>
	<page>
		<module enable-flex>
			<m-search ref="search" @search="searchHandle">
				<c-form ref="searchForm" inline>
					<c-form-item type="input" label="手机号" name="user_manage_mobilephone"></c-form-item>
					<c-form-item type="input" label="昵称" name="nick_name"></c-form-item>
                    <c-form-item type="input" label="授权代码" name="login_name"></c-form-item>
                    <c-form-item type="select" label="等级" name="user_level" options="USER_LEVEL_AUTH"></c-form-item>
                    <c-form-item type="datetime" date-type="date" label="统计时间" start-name="start_date" end-name="end_date"></c-form-item>
				</c-form>
			</m-search>

			<m-operate>
				<c-button power="b_statistic_platform_user_export" @click="exportData()">导出</c-button>
			</m-operate>
			
			<c-table ref="table">				

				<c-table-column
					label="手机号"
					name="user_manage_mobilephone"
					width="130"
				>
					<template v-slot="{data}">
						<span v-if="data.user_manage_mobilephone">{{data.user_manage_mobilephone}}</span>
						<span v-else style="color:#999">--</span>
					</template>
				</c-table-column>
				
				<c-table-column
					label="昵称"
					name="nick_name"
				  width="200"
				>
					<template v-slot="{data}">
						<div class="flex-center-cross">
							<c-image :src="data.head_photo" preview size="30" style="margin-right: 10px;"> </c-image>
							<span v-if="data.nick_name && data.nick_name!=''">{{data.nick_name}}</span>
							<span v-else>--</span>
						</div>
					</template>
				</c-table-column>

                <c-table-column
                        label="授权代码"
                        name="login_name"
                        width="200"
                >
                </c-table-column>

                <c-table-column
                        label="等级"
                        name="level_name"
                >
                    <template v-slot="{data}">
                        <span v-if="data.level_name && data.level_name!='' && data.level_name!='普通用户'" style="color:blue">{{data.level_name}}</span>
                        <span v-else>{{data.level_name}}</span>
                    </template>
                </c-table-column>

                <c-table-column
                        label="月度目标"
                        name="month_target"
                        width="100"
                >
                    <template v-slot="{data}">
                        <span v-if="data.month_target">￥{{data.month_target}}</span>
                        <span v-else>--</span>
                    </template>
                </c-table-column>

                <c-table-column
                        label="季度目标"
                        name="quarterly_target"
                        width="105"
                >
                    <template v-slot="{data}">
                        <span v-if="data.quarterly_target">￥{{data.quarterly_target}}</span>
                        <span v-else>--</span>
                    </template>
                </c-table-column>

                <c-table-column
                        label="年度目标"
                        name="year_target"
                        width="110"
                >
                    <template v-slot="{data}">
                        <span v-if="data.year_target">￥{{data.year_target}}</span>
                        <span v-else>--</span>
                    </template>
                </c-table-column>

				<c-table-column
					label="下单商品数量"
					name="order_quantity"
					width="130"
				>
				</c-table-column>
				
				<c-table-column
					label="下单总额"
					name="order_amount"
					width="110"
				>
					<template v-slot="{data}">
						￥{{data.order_amount}}
					</template>
				</c-table-column>

				<c-table-column
					label="当前等级下单额"
					name="current_level_order_amount"
					width="130"
				>
					<template v-slot="{data}">
						￥{{data.current_level_order_amount}}
					</template>
				</c-table-column>


				<c-table-column
					label="退款数量"
					name="refund_quantity"
					width="100"
				>
				</c-table-column>

				<c-table-column
					label="退款总额"
					name="refund_amount"
					width="110"
				>
					<template v-slot="{data}">
						￥{{data.refund_amount}}
					</template>
				</c-table-column>

				<c-table-column
					label="售后数量"
					name="return_quantity"
					width="100"
				>
				</c-table-column>

				<c-table-column
					label="售后总额"
					name="return_amount"
					width="110"
				>
					<template v-slot="{data}">
						￥{{data.return_amount}}
					</template>
				</c-table-column>

			</c-table>
		</module>
	</page>
</template>

<script>
	export default {
		name: 'm_statistic_platform_user',
		data() {
			return {
				
			}
		},
		
		mounted() {
			this.$refs.search.search();
		},
		
		methods: {
			searchHandle(data) {
				this.$refs.table.load({
					url: '/statistic/platform_user/list',
					data
				});
			},
			exportData(){
				var exportData = this.$refs.searchForm.serialize();
				exportData.job_id = 31;
				exportData.create_system = 'OMS';
				
				this.request({
					url: '/export_job/add',
					data: exportData,
					success: data => {
						this.$message({
		                  	text: '导出任务创建成功，请前往任务中心查看导出进度',
		                  	icon: 'success'
		                });
					}
				});
			}
		}
	}
</script>

<style lang="stylus" scoped>
	
</style>